import { useEffect, useState } from "react";
import enCountries from "../i18n/countries/countries-en.json";
import { getCountryFromIP } from "../utils";

export function useCountryFromIP() {
  const [country, setCountry] = useState("");

  useEffect(() => {
    async function fetchCountry() {
      try {
        const country = await getCountryFromIP();
        const isCountryAvailable = Object.keys(enCountries).some(
          (countryCode) => countryCode === country
        );
        if (isCountryAvailable) setCountry(country);
      } catch (error) {
        console.error("Failed to fetch country:", error);
      }
    }
    fetchCountry();
  }, []);

  return country;
}
